<template>
    <el-table-column :prop="prop" :label="label" >
      <template slot-scope="scope">
        <span  v-if="datasources">
            <router-link class="noline" target="_blank" :to="{ name: routeName, query: { depId: scope.row.depId, datasources: datasources, ...extraQueryParams} }">
              <span class="num">{{ scope.row[prop] }}</span>
            </router-link>
        </span>
        <span v-else>
          {{ scope.row[prop] }}
        </span>
      </template>
    </el-table-column>
  </template>
  
  <script>
  export default {
    props: {
      prop: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      routeName: {
        type: String,
        required: true
      },
      datasources: {
        default: null
      },
      extraQueryParams: {
        type: Object,
        default: () => ({})
        },
    },
    mounted(){
      // console.log(this.extraQueryParams,'=======111========');
    }
  };
  </script>
  
  <style scoped>
  .noline {
    text-decoration: none;
  }
  .num {
    cursor: pointer;
  }
  </style>
  